import { Log } from '@ainova/core';
import { TelemetryService } from './service';
import { env } from '$lib/config/environment';

/**
 * Mock adapter for the telemetry service that logs to the console.
 */
export class TelemetryServiceMock extends TelemetryService {
  private logger = new Log('TelemetryMock');

  async pageView(path: string): Promise<void> {
    if (env.features.debugging) {
      this.logger.debug('page_view', { path });
    }
  }

  async event(name: string, params?: Record<string, unknown>): Promise<void> {
    if (env.features.debugging) {
      this.logger.debug('event', { name, params });
    }
  }

  async timing(name: string, value: number): Promise<void> {
    if (env.features.debugging) {
      this.logger.debug('timing', { name, value: `${value}ms` });
    }
  }
}
